import { View, type StyleProp, type ViewStyle } from "react-native";
import type { LucideIcon } from "lucide-react-native";
import { CardSurface } from "./CardSurface";
import { MoonDetailRow } from "./MoonDetailRow";

export type Fact = {
  key: string;
  label: string;
  value: string;
  icon: LucideIcon;
};

type Props = {
  facts: Fact[];
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

/**
 * An "At a glance" grid: short facts two to a row, each on its own panel
 * tile so the eye can scan them one by one. Tiles in a row share a height.
 * Use it for facts that sit directly on a card or sheet; facts already
 * inside a panel use `MoonDetailRow` on their own.
 */
export function FactGrid({ facts, style, testID }: Props) {
  if (facts.length === 0) return null;

  return (
    <View
      testID={testID}
      style={[
        {
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-between",
          rowGap: 8,
        },
        style,
      ]}
    >
      {facts.map((fact) => (
        <CardSurface
          key={fact.key}
          variant="panel"
          style={{ width: "48.5%", padding: 12 }}
        >
          <MoonDetailRow
            icon={fact.icon}
            label={fact.label}
            value={fact.value}
          />
        </CardSurface>
      ))}
    </View>
  );
}
